import React, { useContext } from "react";
import "./Tickets.css";
import { setTicketStatus } from "../../../Redux/Actions/TechAppAction";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { techappContext } from "../../../Api/techappReq";
import FormatHelper from "../../../Helper/FormatHelper";
import TicketPage from "../../Pages/TicketPage";
import PvMessages from "../../Pages/PvMessages";
import PubMessages from "../../Pages/PubMessages";
import EdMessages from "../../Pages/EdMessages";
import plusImage from "../../../assets/images/plus.svg";
import Colors from "../../../Helper/Colors";
import Header from "../header";
import lang from "../lang/lang.json";
import Layout from "../../../layout";
import { toast } from "react-toastify";

const Tickets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ticketStatus = useSelector(
    (state) => state.TechAppReducer.ticketStatus
  );
  const { getBadges } = useContext(techappContext);

  const clickZero = () => {
    dispatch(setTicketStatus(0));
  };
  const clickOne = () => {
    dispatch(setTicketStatus(1));
  };
  const clickTwo = () => {
    dispatch(setTicketStatus(2));
  };
  const clickThree = () => {
    dispatch(setTicketStatus(3));
  };

  return (
    <Layout>
      <div className="tech-app-messgaes">
        <Header title={lang.KARABAMA} />
        {ticketStatus === 0 && (
          <div
            onClick={() => {
              if (!localStorage.getItem("auth_from_admin")) {
                navigate("/techapp/create-ticket");
              } else {
                toast.error("شما از پنل ادمین وارد شده اید و دسترسی ندارید.");
              }
            }}
            style={
              localStorage.getItem("auth_from_admin")
                ? {
                    backgroundColor: Colors.warning,
                    zIndex: "100000",
                    cursor: "not-allowed",
                    filter: "blur(1px)",
                  }
                : { backgroundColor: Colors.warning, zIndex: "100000" }
            }
            className="tech-app-transaction-deposit"
            id="tech-app-transaction-deposit"
          >
            <img style={{ width: "25%" }} src={plusImage} alt="new ticket" />
          </div>
        )}
        {/* tabs */}
        <div className="techapp-tickets-status">
          {/* tickets tab */}
          <div
            className={
              ticketStatus === 0 ? "techapp-tickets-status-selected" : ""
            }
            onClick={clickZero}
          >
            <span style={{ position: "relative" }}>
              {lang.TICKETS}
              {getBadges && getBadges.ticket > 0 && (
                <span className="techapp-ticket-status-unread-messages">
                  {FormatHelper.toPersianString(getBadges.ticket)}
                </span>
              )}
            </span>
          </div>
          {/* privates tab */}
          <div
            className={
              ticketStatus === 1 ? "techapp-tickets-status-selected" : ""
            }
            onClick={clickOne}
          >
            <span style={{ position: "relative" }}>
              {lang.PRIVATE_MESSAGE}
              {getBadges && getBadges.private > 0 && (
                <span className="techapp-ticket-status-unread-messages">
                  {FormatHelper.toPersianString(getBadges.private)}
                </span>
              )}
            </span>
          </div>
          {/* public tab  */}
          <div
            className={
              ticketStatus === 2 ? "techapp-tickets-status-selected" : ""
            }
            onClick={clickTwo}
          >
            <span style={{ position: "relative" }}>
              {lang.GLOBAL_MESSAGE}
              {getBadges && getBadges.public > 0 && (
                <span className="techapp-ticket-status-unread-messages">
                  {FormatHelper.toPersianString(getBadges.public)}
                </span>
              )}
            </span>
          </div>
          {/* trainings tab */}
          <div
            className={
              ticketStatus === 3 ? "techapp-tickets-status-selected" : ""
            }
            onClick={clickThree}
          >
            <span style={{ position: "relative" }}>
              {lang.EDUCATIONS}
              {getBadges && getBadges.training > 0 && (
                <div className="techapp-ticket-status-unread-messages">
                  {FormatHelper.toPersianString(getBadges.training)}
                </div>
              )}
            </span>
          </div>
        </div>
        <div className="techapp-tickets-body">
          {ticketStatus === 0 && <TicketPage />}
          {ticketStatus === 1 && <PvMessages />}
          {ticketStatus === 2 && <PubMessages />}
          {ticketStatus === 3 && <EdMessages />}
        </div>
      </div>
    </Layout>
  );
};
export default Tickets;
